import { FC, ReactNode } from "react"
import Modal from "./Modal"

type Props = {
  html: string
  close(): void
  title?: ReactNode
}

const HtmlRenderModal: FC<Props> = ({ close, html, title }) => {
  return (
    <Modal
      close={close}
      title={title}
      className="submission-code-modal"
    >
      <div className="border border-gray-300 rounded px-10 py-8">
        <div dangerouslySetInnerHTML={{ __html: html }} className="challenge-card" />
      </div>
    </Modal>
  )
}

export default HtmlRenderModal
